import { IndustryQueryProvider } from "__legacy/queries/industries/IndustryQueryProvider";
import { UpdateIndustryMutationProvider } from "__legacy/queries/industries/UpdateIndustryMutationProvider";
import { Button, Form, Layout, PageHeader } from "antd";
import { Fragment, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { ClassificationForm, onError, onFinish } from "./ClassificationForm";

export const Edit: React.FC<{}> = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [errors, setErrors] = useState<string[]>([]);

  return (
    <IndustryQueryProvider variables={{ id }}>
      {({ industry }) => (
        <UpdateIndustryMutationProvider onError={onError(form, setErrors)} onCompleted={() => navigate("../")}>
          {(loading, mutate) => (
            <Fragment>
              <PageHeader
                ghost={true}
                title={`Edit industry ${industry.name}`}
                extra={
                  <Fragment>
                    <Button onClick={() => navigate("../../")}>Back to list</Button>
                    <Button onClick={() => navigate("../")}>Back to details</Button>
                    <Button type="primary" loading={loading} onClick={() => form.submit()}>
                      Save
                    </Button>
                  </Fragment>
                }
              />
              <Layout.Content className="content">
                <ClassificationForm
                  action="update"
                  form={form}
                  handler={onFinish(mutate, {}, { id })}
                  values={industry}
                  errors={errors}
                />
              </Layout.Content>
            </Fragment>
          )}
        </UpdateIndustryMutationProvider>
      )}
    </IndustryQueryProvider>
  );
};
